import '@/styles/index.less';

// 引入静态资源
export const setupAssets = () => ({});
